const handleCursor = () => {
  const cursor = document.querySelector('.cursor');
  const section = document.querySelector('.home-portfolio__slider');
  if (cursor) {
    cursor.style.transition = ' transform 400ms, opacity 200ms ';
    section?.addEventListener('mousemove', (e) => {
      const x = e.clientX - cursor.clientWidth / 2;
      const y = e.clientY - cursor.clientHeight / 2;
      cursor.style.top = `${y}px`;
      cursor.style.left = `${x}px`;
    });
    section?.addEventListener('mouseenter', (e) => {
      cursor.style.opacity = 1;
      cursor.style.transform = 'scale(1)';
    });
    section?.addEventListener('mouseleave', (e) => {
      cursor.style.opacity = 0;
      cursor.style.transform = 'scale(0)';
    });
  }
};
export default handleCursor;
